import { SelectProps } from '@radix-ui/react-select';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/Select';

import { useGetAudienceNames } from '@/hooks/useGetAudienceNames';

export function AudienceSelect(props: SelectProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.AudienceNames',
  });
  const { audienceNames } = useGetAudienceNames();

  if (audienceNames.length === 0) {
    return <p className="text-xs font-bold">{t('unavailable')}</p>;
  }

  return (
    <Select {...props}>
      <SelectTrigger>
        <SelectValue placeholder={t('placeholder')} />
      </SelectTrigger>

      <SelectContent>
        {audienceNames.map((item) => (
          <SelectItem key={item.id} value={String(item.id)}>
            {item.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
